module.exports = __webpack_public_path__ + "images/165_4096.jpg";